import LocomotiveScroll from 'locomotive-scroll';
import React, { useEffect, useRef, useState } from 'react';
// import 'locomotive-scroll/dist/locomotive-scroll.css'; // REMOVED
import Navbar from './components/Navbar';
import HeroSection from './sections/HeroSection';
import distributeAndShuffle from './assets/distributeAndShuffle';
import KeenGallery from './sections/KeenGallery';
import WhatWeDoSection from './sections/WhatWeDoSection';
import ContactSection from './sections/ContactSection';
import Footer from './components/Footer';

const App = () => {
  const [imageData, setImageData] = useState([]);
  const [credit, setCredit] = useState('');
  const containerRef = useRef(null);

  useEffect(() => {
    fetch('/gallery/gallery_meta.json')
      .then(res => res.json())
      .then(data => {
        const { copyright, images } = distributeAndShuffle(data);
        setImageData(images);
        setCredit(copyright);
      });
  }, []);

  useEffect(() => {
  if (!containerRef.current || imageData.length === 0) return;

  const scroll = new LocomotiveScroll({
    el: containerRef.current,
    smooth: true,
  });

  return () => {
    scroll.destroy();
  };
}, [imageData]); // Depend on imageData being loaded


  return (
  <>
    <Navbar />
    <div ref={containerRef} data-scroll-container>
      <div className="parallax-section hero-section" data-scroll-section>
        <HeroSection />
      </div>
      <div className="parallax-section2" data-scroll-section>
        <KeenGallery slides={imageData} credit={credit} />
      </div>
      <div className="parallax-section" data-scroll-section>
        <WhatWeDoSection />
      </div>
      <div className="parallax-section" data-scroll-section>
        <ContactSection />
      </div>
      <div className="parallax-section2" data-scroll-section>
        <Footer />
      </div>
    </div>
  </>
);

 
};

export default App;